import { defineMessages } from 'react-intl';

export default defineMessages({
  CONNECTION: {
    defaultMessage: 'Connexion',
  },

  CONNECTION_INFO: {
    defaultMessage: 'Identifiez-vous avec votre compte Google fourni par ENACO.',
  },

  LOGIN: {
    defaultMessage: 'Se connecter avec Google',
  },

  LOGIN_ERROR: {
    defaultMessage:
      "<p><b>Votre identifiant n'est pas reconnu par notre plateforme.</b></p><p>Assurez-vous de bien avoir renseigné votre <b>compte Google</b> fourni par <b>ENACO</b>.</p><p>Si le problème persiste, nous vous invitons à contacter <b>servicepedagogique@enaco.fr</b>.</p>",
  },

  LOGIN_BLOCKED_ERROR: {
    defaultMessage:
      "<p><b>Ce compte a été désactivé.</b></p><p>Si vous pensez qu'il s'agit d'une erreur, nous vous invitons à contacter <b>servicepedagogique@enaco.fr</b>.</p>",
  },
} as const);
